import { render } from "./LinkImportSource.vue?vue&type=template&id=518870c2&ts=true"
import script from "./LinkImportSource.vue?vue&type=script&lang=ts"
export * from "./LinkImportSource.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\mariano.mertinat\\IdeaProjects\\fabri\\fabri-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__